import { useEffect } from 'react';
import { useRecipeFilterContext } from '@/context/recipeFilter';

export default ({ hasLoadMore, browseBy }) => {
  const [
    state,
    { setLoadMore, setFirstQuery, setBrowseBy },
  ] = useRecipeFilterContext();
  useEffect(() => {
    const dataUrl = new URLSearchParams(window.location.search);
    dataUrl.set('hasLoadMore', hasLoadMore);
    const initialUrl = `${window.location.pathname}?${dataUrl.toString()}`;
    const initialQuery = {
      value: dataUrl.get('q'),
      url: initialUrl,
    };
    setLoadMore(hasLoadMore);
    setFirstQuery(initialQuery);
    setBrowseBy(browseBy);

    // replace state w/ initialState
    window.history.replaceState(
      {
        ...state,
        query: initialQuery,
        browseBy,
        hasLoadMore,
      },
      null,
      initialUrl,
    );
  }, []);
};
